import { render } from "./knowledge.vue?vue&type=template&id=62855f38&scoped=true"
import script from "./knowledge.vue?vue&type=script&lang=js"
export * from "./knowledge.vue?vue&type=script&lang=js"

import "./knowledge.vue?vue&type=style&index=0&id=62855f38&lang=less&scoped=true"
import "./knowledge.vue?vue&type=style&index=1&id=62855f38&lang=less"

import exportComponent from "D:\\微客\\we_customer_guide\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62855f38"]])

export default __exports__